module.exports = __webpack_public_path__ + "img/graphPlaceholder.592a0fe9.png";